import React from 'react';
import { connect } from 'react-redux';
import { isNil } from 'ramda';
import AddModuleButton from 'manage-modules/components/AddModuleButton';
import ModuleCard from 'manage-modules/components/card/ModuleCard';
import ModulesDrawer from 'manage-modules/components/ModulesDrawer';
import PanelLoadingIndicator from 'components/PanelLoadingIndicator';
import styles from 'manage-modules/components/ManageModules.css';
import PanelHeader from "manager-panel/PanelHeader";

const ManageModules = ({ isNew, modulesLoaded, publishingNewModule }) =>
  <div className={styles.panel}>
    <PanelHeader label={isNew && modulesLoaded ? 'New Module' : 'Manage Modules'} icon="extension"/>
    <div className={styles.panelBody}>
      {modulesLoaded
        ? <div className={styles.modulesPanelBodyContainer}>
            <div className={styles.moduleDrawerContainer}>
              <ModulesDrawer />
            </div>
            {isNew && <div className={styles.moduleDrawerOverlay} />}
            <div className={styles.moduleCardContainer}>
              {publishingNewModule ? <PanelLoadingIndicator /> : <ModuleCard />}
            </div>
            {!publishingNewModule && <AddModuleButton />}
          </div>
        : <PanelLoadingIndicator />}
    </div>
  </div>;

const mapStateToProps = state => {
  const {
    moduleCard,
    modulesLoaded,
    publishingNewModule,
  } = state.manageModules;
  return {
    isNew: isNil(moduleCard.module.id),
    modulesLoaded,
    publishingNewModule,
  };
};

export default connect(mapStateToProps)(ManageModules);
